import React, { useEffect, useState } from 'react';
import supabase from '../../../../supabaseClient';

function CalendarAddNewTask({ onClose, presetDate, idConfig }) {
  const [currentManagerId, setCurrentManagerId] = useState(null);
  const [categories, setCategories] = useState([]);
  const [managers, setManagers] = useState([]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const [title, setTitle] = useState('');
  const [date, setDate] = useState(presetDate);
  const [time, setTime] = useState('09:00');
  const [categoryId, setCategoryId] = useState('');
  const [assignedTo, setAssignedTo] = useState('');
  const [notes, setNotes] = useState('');

useEffect(() => {
  let cancelled = false;

  async function load() {
    const { data: { session } } = await supabase.auth.getSession();
    const managerId = session?.user?.id || null;
    if (!cancelled) setCurrentManagerId(managerId);

    if (!idConfig) return;

    const [{ data: catData, error: catError }, { data: mgrData, error: mgrError }] = await Promise.all([
      supabase.from('calendar_categories').select('id, name').eq('id_configuration', idConfig),
      supabase.from('profiles').select('id, full_name').eq('profile_type', 'manager').eq('id_configuration', idConfig),
    ]);
    if (catError) console.error('Błąd pobierania kategorii:', catError);
    if (mgrError) console.error('Błąd pobierania managerów:', mgrError);
    if (cancelled) return;

    setCategories(catData || []);
    if (catData && catData.length > 0) setCategoryId(catData[0].id);

    setManagers(mgrData || []);
    const isLoggedInManagerInList = managerId && mgrData?.some((m) => m.id === managerId);
    if (isLoggedInManagerInList) {
      setAssignedTo(managerId);
    } else if (mgrData && mgrData.length > 0) {
      setAssignedTo(mgrData[0].id);
    }
  }

  load();
  return () => { cancelled = true; };
}, [idConfig]);

  async function handleSave() {
    const trimmedTitle = title.trim();
    if (!trimmedTitle) { setError('Tytuł jest wymagany.'); return; }
    if (!currentManagerId) { setError('Nie udało się ustalić zalogowanego managera — zaloguj się ponownie.'); return; }

    setSaving(true);
    setError(null);
    const { error: insertError } = await supabase.from('calendar_events').insert({
      title: trimmedTitle,
      event_date: date,
      event_time: time,
      category_id: categoryId || null,
      assigned_to: assignedTo || null,
      notes: notes.trim() || null,
      created_by: currentManagerId,
      id_configuration: idConfig,
    });
    setSaving(false);

    if (insertError) {
      console.error('Błąd dodawania akcji:', insertError);
      setError('Nie udało się zapisać akcji. Spróbuj ponownie.');
      return;
    }
    onClose();
  }

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(44,20,25,0.45)', zIndex: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: 16, padding: 28, width: 420, maxWidth: '90vw' }}>
        <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 16, color: '#6B1D2F' }}>Nowa akcja</div>

        <label style={labelStyle}>Tytuł</label>
        <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="np. Rozmowa z klientem" style={inputStyle} />

        <div style={{ display: 'flex', gap: 10, marginBottom: 14 }}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Data</label>
            <input type="date" value={date} onChange={(e) => setDate(e.target.value)} style={inputStyle} />
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Godzina</label>
            <input type="time" value={time} onChange={(e) => setTime(e.target.value)} style={inputStyle} />
          </div>
        </div>

        <label style={labelStyle}>Kategoria</label>
        <select value={categoryId} onChange={(e) => setCategoryId(e.target.value)} style={inputStyle}>
          {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>

        <label style={labelStyle}>Przypisana osoba</label>
        <select value={assignedTo} onChange={(e) => setAssignedTo(e.target.value)} style={inputStyle}>
          {managers.map((m) => <option key={m.id} value={m.id}>{m.full_name}</option>)}
        </select>

        <label style={labelStyle}>Notatka</label>
        <textarea value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Opcjonalnie" style={{ ...inputStyle, minHeight: 56, resize: 'vertical' }} />

        {error && <div style={{ color: '#c0392b', fontSize: 12, marginBottom: 10 }}>{error}</div>}

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 8 }}>
          <button onClick={onClose} style={{ background: 'none', border: '1px solid #e3d9d9', padding: '9px 16px', borderRadius: 8, fontSize: 13, fontWeight: 600, color: '#705A5E', cursor: 'pointer' }}>
            Anuluj
          </button>
          <button onClick={handleSave} disabled={saving} style={{
            background: '#6B1D2F', border: 'none', padding: '9px 18px', borderRadius: 8,
            fontSize: 13, fontWeight: 700, color: '#fff', cursor: saving ? 'default' : 'pointer', opacity: saving ? 0.6 : 1,
          }}>
            {saving ? 'Zapisywanie…' : 'Zapisz'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CalendarAddNewTask;

const labelStyle = { display: 'block', fontSize: 12, color: '#705A5E', marginBottom: 4 };
const inputStyle = { width: '100%', boxSizing: 'border-box', padding: '9px 10px', border: '1px solid #e3d9d9', borderRadius: 8, fontSize: 14, marginBottom: 14 };